import { render, staticRenderFns } from "./UcbForms.vue?vue&type=template&id=65de1110&scoped=true"
import script from "./UcbForms.vue?vue&type=script&lang=ts"
export * from "./UcbForms.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65de1110",
  null
  
)

export default component.exports